/**
 * 定義XMLの索引キー。複数BPMN/DMNや旧runの同名要素IDを混線させないために使う。
 * 暗号用途ではないので、環境差の無い決定的な短いhash（FNV-1a 64bit相当）で足りる。
 */
export function contentDigest(text: string): string {
  let hi = 0x811c9dc5;
  let lo = 0xcbf29ce4;
  for (let i = 0; i < text.length; i += 1) {
    const code = text.charCodeAt(i);
    lo ^= code & 0xff;
    hi ^= (code >>> 8) & 0xff;
    lo = Math.imul(lo, 0x01000193) >>> 0;
    hi = Math.imul(hi, 0x01000193) >>> 0;
  }
  return `${hi.toString(16).padStart(8, '0')}${lo.toString(16).padStart(8, '0')}`;
}
